/* KEY STUDIO v4 : entrée du premier écran, en-tête au défilement, parallaxe douce,
   estimation en direct de l'accueil et passage des choix au simulateur de la page Tarifs.
   Le simulateur garde son propre script, inchangé : on ne fait que cocher ses cases. */
(function () {
  "use strict";
  var doc = document.documentElement;
  var reduit = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Entrée du premier écran : après le premier rendu, pour que la transition se joue. */
  (window.introLogo || Promise.resolve()).then(function () { requestAnimationFrame(function () { requestAnimationFrame(function () { doc.classList.add("k4-anime"); }); }); });

  /* En-tête : ombre dès qu'on défile. */
  var entete = document.querySelector(".k4-entete");
  var parallaxes = reduit ? [] : Array.prototype.slice.call(document.querySelectorAll("[data-parallaxe]"));
  var attente = false;
  var auDefilement = function () {
    attente = false;
    var y = window.scrollY;
    if (entete) entete.classList.toggle("k4-defile", y > 8);
    var h = window.innerHeight;
    parallaxes.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > h + 100) return;
      var f = parseFloat(el.getAttribute("data-parallaxe")) || 0.1;
      var centre = r.top + r.height / 2 - h / 2;
      el.style.transform = "translate3d(0," + (-centre * f).toFixed(1) + "px,0)";
    });
  };
  window.addEventListener("scroll", function () { if (!attente) { attente = true; requestAnimationFrame(auDefilement); } }, { passive: true });
  window.addEventListener("resize", auDefilement, { passive: true });
  auDefilement();

  var euros = function (n) {
    var c = Math.round(n * 100);
    var e = Math.floor(c / 100), r = c % 100;
    return e + (r ? "," + String(r).padStart(2, "0") : "") + " €";
  };

  /* Estimation en direct de l'accueil (affichage seulement). */
  var simu = document.querySelector("[data-k4-simu]");
  if (simu) {
    var pct = parseFloat(simu.getAttribute("data-acompte")) || 30;
    var sortie = simu.querySelector("[data-k4-total]");
    var actuel = parseFloat(sortie.textContent) || 0, anim = null;
    var animer = function (cible) {
      if (anim) cancelAnimationFrame(anim);
      if (reduit) { actuel = cible; sortie.textContent = cible; return; }
      var depart = actuel, t0 = null;
      var pas = function (t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / 520), e = 1 - Math.pow(1 - k, 3);
        actuel = depart + (cible - depart) * e;
        sortie.textContent = Math.round(actuel);
        if (k < 1) anim = requestAnimationFrame(pas); else actuel = cible;
      };
      anim = requestAnimationFrame(pas);
    };
    var coche = function (nom) { return simu.querySelector('input[name="' + nom + '"]:checked'); };
    var maj = function () {
      var total = 0, details = [];
      ["formule", "surface", "zone"].forEach(function (nom) {
        var i = coche(nom);
        if (!i) return;
        var p = parseFloat(i.getAttribute("data-prix")) || 0;
        total += p;
        var l = simu.querySelector('[data-k4-l="' + nom + '"]');
        var v = simu.querySelector('[data-k4-p="' + nom + '"]');
        var lib = i.getAttribute("data-libelle");
        if (l) l.textContent = nom === "formule" ? lib : nom === "surface" ? "Surface " + lib : "Déplacement " + lib;
        if (v) v.textContent = nom === "formule" ? euros(p) : p === 0 ? (nom === "zone" ? "Offert" : "Compris") : "+" + euros(p);
      });
      animer(total);
      var a = Math.round(total * pct) / 100;
      simu.querySelector("[data-k4-acompte]").textContent = euros(a);
      simu.querySelector("[data-k4-solde]").textContent = euros(total - a);
      var d = simu.querySelector("[data-k4-detail]");
      if (d) d.textContent = "dont " + euros(a) + " en réservant";
    };
    simu.addEventListener("change", maj);
    maj();
    simu.addEventListener("submit", function (e) {
      e.preventDefault();
      var q = [];
      ["formule", "surface", "zone"].forEach(function (nom) {
        var i = coche(nom);
        if (i) q.push(nom + "=" + encodeURIComponent(i.getAttribute("data-valeur")));
      });
      location.href = "/pages/tarifs?" + q.join("&") + "#reservation";
    });
  }

  /* Page Tarifs : reprend les choix faits sur l'accueil dans le simulateur. */
  if (/^\/pages\/tarifs/.test(location.pathname) && location.search) {
    var params = new URLSearchParams(location.search);
    var cocher = function (classe, valeur) {
      if (!valeur) return;
      var cases = document.querySelectorAll("input." + classe);
      for (var k = 0; k < cases.length; k++) {
        if (cases[k].value === valeur && !cases[k].hasAttribute("data-abo")) {
          cases[k].checked = true;
          cases[k].dispatchEvent(new Event("input", { bubbles: true }));
          cases[k].dispatchEvent(new Event("change", { bubbles: true }));
          return;
        }
      }
    };
    var appliquer = function () {
      cocher("ks-pack", params.get("formule"));
      cocher("ks-surface", params.get("surface"));
      cocher("ks-zone", params.get("zone"));
      /* Rien à ressaisir : la formule et la surface sont reprises, le simulateur s'ouvre sur l'adresse.
         La zone de l'accueil n'est qu'une estimation : le code postal tapé ensuite la corrige d'office. */
      if (!params.get("formule") || typeof ksaAller !== "function") return;
      try { ksZoneManuelle = false; } catch (e) {}
      var pack = document.querySelector("input.ks-pack:checked"), surf = document.querySelector("input.ks-surface:checked");
      var etape = document.querySelector('#booking-form [data-ksa-etape="2"]');
      if (etape && pack && !etape.querySelector(".ksa-repris")) {
        var note = document.createElement("p");
        note.className = "ksa-repris";
        /* Depuis une carte de formule (v6), seule la formule est transmise : on n'affiche pas une surface que le visiteur n'a pas choisie. */
        var avecSurface = !!params.get("surface");
        note.innerHTML = "<span>" + (avecSurface ? "Repris de votre estimation" : "Formule choisie") + " : <b></b></span><button type=\"button\" class=\"ksa-lien\" data-ksa-aller=\"1\">Modifier</button>";
        note.querySelector("b").textContent = [pack.value.split(" — ")[0], avecSurface && surf ? surf.value : ""].filter(Boolean).join(" · ");
        etape.insertBefore(note, etape.firstChild);
      }
      ksaAller(2, false);
    };
    if (document.readyState === "complete") appliquer(); else window.addEventListener("load", appliquer);
  }

  /* Formulaire de demande : on ramène le visiteur sur le message de remerciement. */
  var merci = document.querySelector("[data-k4-merci]");
  if (merci) setTimeout(function () { merci.scrollIntoView({ block: "center" }); merci.focus({ preventScroll: true }); }, 350);
})();

/* Téléphone : compteur de la rangée de photos à faire glisser. */
(function () {
  var rang = document.querySelector("[data-k4-glisse]");
  var cpt = document.querySelector("[data-k4-compteur]");
  if (!rang || !cpt) return;
  var items = rang.children, n = items.length, attente = false;
  var deux = function (x) { return String(x).padStart(2, "0"); };
  var maj = function () {
    attente = false;
    var g = rang.getBoundingClientRect().left, meilleur = 0, d = Infinity;
    for (var i = 0; i < n; i++) { var e = Math.abs(items[i].getBoundingClientRect().left - g - 20); if (e < d) { d = e; meilleur = i; } }
    if (rang.scrollLeft + rang.clientWidth >= rang.scrollWidth - 4) meilleur = n - 1;
    cpt.textContent = deux(meilleur + 1) + " / " + deux(n);
  };
  rang.addEventListener("scroll", function () { if (!attente) { attente = true; requestAnimationFrame(maj); } }, { passive: true });
  maj();
})();

/* Téléphone : onglets des offres (À la carte, Agences, Signature) reliés à la rangée qui glisse. */
(function () {
  var rang = document.querySelector("[data-k4-offres]");
  var onglets = document.querySelectorAll("[data-k4-onglet]");
  if (!rang || !onglets.length) return;
  var cartes = rang.children, attente = false;
  var activer = function (i) { onglets.forEach(function (b, k) { b.setAttribute("aria-pressed", k === i ? "true" : "false"); }); };
  onglets.forEach(function (b) {
    b.addEventListener("click", function () {
      var i = +b.getAttribute("data-k4-onglet");
      if (!cartes[i]) return;
      rang.scrollTo({ left: cartes[i].offsetLeft - rang.firstElementChild.offsetLeft, behavior: "smooth" });
      activer(i);
    });
  });
  rang.addEventListener("scroll", function () {
    if (attente) return;
    attente = true;
    requestAnimationFrame(function () {
      attente = false;
      var g = rang.getBoundingClientRect().left, meilleur = 0, d = Infinity;
      for (var i = 0; i < cartes.length; i++) { var e = Math.abs(cartes[i].getBoundingClientRect().left - g - 20); if (e < d) { d = e; meilleur = i; } }
      if (rang.scrollLeft + rang.clientWidth >= rang.scrollWidth - 4) meilleur = cartes.length - 1;
      activer(meilleur);
    });
  }, { passive: true });
})();

/* Téléphone : chaque rangée [data-k4-defile] reçoit son compteur « 01 / 04 · Faites glisser ». */
(function () {
  var fleche = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 12h14m-5-5 5 5-5 5"/></svg>';
  document.querySelectorAll("[data-k4-defile]").forEach(function (rang) {
    var n = rang.children.length;
    if (n < 2) return;
    var pied = document.createElement("div");
    pied.className = "k4-glisse-pied"; pied.setAttribute("data-auto", ""); pied.setAttribute("aria-hidden", "true");
    pied.innerHTML = '<span></span><span class="k4-glisse-aide">Faites glisser ' + fleche + "</span>";
    rang.parentNode.insertBefore(pied, rang.nextSibling);
    var cpt = pied.firstChild, attente = false, deux = function (x) { return String(x).padStart(2, "0"); };
    var maj = function () {
      attente = false;
      var g = rang.getBoundingClientRect().left, meilleur = 0, d = Infinity;
      for (var i = 0; i < n; i++) { var e = Math.abs(rang.children[i].getBoundingClientRect().left - g - 20); if (e < d) { d = e; meilleur = i; } }
      if (rang.scrollLeft + rang.clientWidth >= rang.scrollWidth - 4) meilleur = n - 1;
      cpt.textContent = deux(meilleur + 1) + " / " + deux(n);
    };
    rang.addEventListener("scroll", function () { if (!attente) { attente = true; requestAnimationFrame(maj); } }, { passive: true });
    maj();
  });
})();

/* Téléphone : le formulaire de demande de l'accueil reste replié tant qu'on ne l'ouvre pas. */
(function () {
  var bloc = document.querySelector("[data-k4-repliable]");
  if (!bloc || bloc.querySelector("[data-k4-merci], .k4-erreur")) return;
  bloc.setAttribute("data-replie", "");
  var b = bloc.querySelector(".k4-demande-ouvrir");
  if (b) b.addEventListener("click", function () { bloc.removeAttribute("data-replie"); var c = bloc.querySelector("input"); if (c) c.focus(); });
})();
